import { render, staticRenderFns } from "./customReplaceTmp.vue?vue&type=template&id=68bedfea&scoped=true&"
import script from "./customReplaceTmp.vue?vue&type=script&lang=js&"
export * from "./customReplaceTmp.vue?vue&type=script&lang=js&"
import style0 from "./customReplaceTmp.vue?vue&type=style&index=0&id=68bedfea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68bedfea",
  null
  
)

export default component.exports